export default "__VITE_ASSET__CqHfjD6Q__"